import React, {Fragment, useContext,useEffect, useState, useRef} from 'react'
import { InfoContext } from '../../../context/Context';
import './styles/_aboutus.scss';
import ShortForm from '../../sections/ShortForm/ShortForm';

export default function AboutUs() {

    const { storeUberall, data }   = useContext(InfoContext);
    const { htmlContent } = data.momentFeed.html;
    const contentRef = useRef(null);
    const [map, setMap] = useState([]);
    const [brand, setBrand] = useState(false);
    const [classCss, seclassCss] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [storeId, setStoreId] = useState(null);
    useEffect(() => {
        if(storeUberall !== undefined){
            
            const google = `https://maps.google.com/?q=:${storeUberall.streetAndNumber} ${storeUberall.city}  ${storeUberall.province}  ${storeUberall.zip}`;
            setMap(google);
            if(data.momentFeed.name === "Check Into Cash" ||  data.momentFeed.name === "Easy Money" ||  data.momentFeed.name === "CheckSmart"  ){
                setBrand(true);
            }
            else{
                seclassCss("autoH"); 
            }
        }
    }, [storeUberall])

    const CustomMap = () =>{
        if(contentRef.current){
            const elements = contentRef.current.querySelectorAll('.cic-local-address');
            elements.forEach((element) => {
                element.setAttribute('href', map);
            });
        }
    }
    const bringImg = () => {   
        return(             
          <img  className="lazy entered lazyloaded" alt="About us image" src="https://localstoresprd.wpenginepowered.com/wp-content/uploads/2022/03/family-sidewalk-swinging.webp" />
        )
    }
    const handleGetStarted = (storeId) => {
        setStoreId(storeId);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
      };
    const renderAbout = () => {
        return (
          <section id="GetStarted">
              <div className="cic-how-it-works-wrapper">
                  <div className="cic-how-it-works-heading">
                      <h2 className="center">About {data.momentFeed.name} {data.momentFeed.locality}, {data.momentFeed.state_min}</h2>
                  </div>
                  <div className={`cic-how-it-works-img ${classCss}`} >
                      {
                          ( data.momentFeed.name === "Check Into Cash") 
                          ? 
                              ( bringImg() )  
                          : 
                         (
                            <>
                                <div ref={contentRef} dangerouslySetInnerHTML={{ __html: data.momentFeed.html}}></div>
                                {
                                    CustomMap()
                                }
                            </>
                            
                         )
                      } 
                  </div>
                  <div className="cic-how-it-works-btns">
                      <a 
                          onClick={() => handleGetStarted(storeUberall.identifier)}  
                          className="cic-btn cic-btn-primary cursor my-3" 
                          aria-label={`Click here to apply for a ${data.momentFeed.name} Payday Loan now`}
                      > 
                          {
                              (brand) ? "Get Started" : "Get Started Online"
                          }
                          
                      </a>
                      <a 
                          href={`/store-locator/`} 
                          className="cic-btn checksmart-btn-secondary my-3" 
                          title="Click here to Find Locations near you" 
                          aria-label="Click here to Find Locations near you" 
                          rel="noopener noreferrer">
                              Find Locations
                      </a>
                  </div>
              </div>
                {
                    (showModal === true) ?
                        (  <ShortForm 
                            storeId={storeId}
                            zip={storeUberall.zip}
                            showModal={showModal} 
                            handleCloseModal={handleCloseModal} 
                        />) 
                        : 
                        <></>
                }
          </section>
        )

    }
  return (
    <Fragment> 
        {
             ( storeUberall !== null && data !== null) ? ( renderAbout() )  : <></>
        } 
    </Fragment>
  )
}
